import { PayloadAction } from '@reduxjs/toolkit';
import { AnyAction } from 'redux';
import { createReducer } from 'redux-create-reducer';
import {
  FetchGroupRoles,
  FetchSharedGroupRoles,
  SetProductFilterOptions,
  SetRegionFilterOptions,
  SetProductFilterSelectedOption,
  SetAssignedRolesTablePagination,
  SetAssignedRolesTableSearch,
  SetDrawerRolesTable,
  SetUserTableSelectedRows,
  SetUsersTablePagination,
  SetUsersTableSearch,
  ClearMapGroupsStepper,
  SetSelectedUsersAddGroupDrawer,
  UpdateGroupsSearchField,
  UpdateTableConfigData,
  ToggleGroupsDrawerVisibility,
  ChangeNameForNewGroupIdpStepper,
  ChangeDescriptionForNewGroupIdpStepper,
  CreateGroup,
  SetMapGroupRowsData,
  FetchGroupMappings,
  SetAssignRolesTableDrawer,
  ToggleAssignRolesDrawerVisibility,
  UpdateGroupMappings,
  CloseMapGroupsErrorBanner,
  FetchIdpGroups,
  SetUsersTableSorting,
  SetRolesTableSorting,
  ClearEditGroup,
  SetAddGroupStep,
  SetTypeFilterSelectedOption,
  SetTypeFilterOptions,
  SetMapIdentityProviderStep,
  FetchGroupUsers,
  DeleteGroup,
  FetchGroupById,
  EditGroup,
  HideDeleteGroupModal,
  ShowDeleteGroupModal,
  ShowAddUsersDrawer,
  HideAddUsersDrawer,
  ShowEditGroupNameDrawer,
  HideEditGroupNameDrawer,
  ShowDiscardChangesModal,
  HideDiscardChangesModal,
  ShowAssignRolesDrawer,
  HideAssignRolesDrawer,
  SetUsersOptionsFromDrawer,
  SetUsersOptions,
  ChangeNameField,
  AddNotification,
  AddGroupTelemetryErrorNotification,
  ChangeDescriptionField,
  HideNotification,
  HideAllEditGroupDrawers,
  DiscardAddGroupChanges,
  SetActiveDeleteGroupId,
  ChangeNameFieldFromDrawer,
  ChangeDescriptionFieldFromDrawer,
  SelectActiveDeleteUsers,
  SelectActiveDeleteSingleUser,
  SelectActiveDeleteRole,
  ClearAllEditGroupDrawers,
  HideRemoveModal,
  CloseGetIdpGroupsErrorBanner,
  SetRemovedUsersCount,
  ClearRemovedUsersCount,
  IncrementAddedUsersCount,
  ClearAddedUsersCount,
  SetGroupsTypeSelectedFilter,
  SetManagedOrgsTableSorting,
  SetManagedOrgsTableSearch,
  SetManagedOrgsTablePagination,
  SetManagedOrgRemovalModalVisible,
  CloseManagedOrgRemovalModal,
  SetManagedOrgRemovalSelectedItem,
  RemoveManagedOrg,
  RemoveManagedOrgErrorBanner,
  ShowManagedOrgDrawer,
  HideManagedOrgDrawer,
  SetSelectedManagedOrg,
  ShareManagedOrganization,
  appliesTo,
} from './actions';
import { extractProductsFromRoles } from './helpers';
import { IMapGroupFormRow } from './MapIdentityProvidersGroups/interfaces';
import { AddedUserMode, RemovedUserMode } from '../../enums/Groups';
import {
  IGroups,
  IRolesRows,
  ISharedGroupRole,
} from '../../interfaces/IGroups';
import { TABLE_CONFIG } from '../../utils/constant';

export const initialState: IGroups = {
  activeEditGroupId: null,
  activeDeleteGroupId: null,
  groupUsers: [],
  groupsTableSearchField: '',
  groupsPagination: {
    pageSize: TABLE_CONFIG.paginationConfig.pageSize,
    pageIndex: 0,
  },
  idpGroups: {
    data: [],
    error: null,
  },
  addGroup: {
    stepper: {
      appliesTo: {
        value: '',
      },
      name: {
        value: '',
        touched: false,
        focused: false,
        errorMessage: 'groups:stepper.groupDetailsStep.nameFieldRequiredError',
      },
      description: {
        value: '',
        touched: false,
        focused: false,
        errorMessage: null,
      },
      currentStep: 1,
      usersOptions: [],
      selectedUsersOptions: [],
    },
    newGroupName: '',
  },
  editGroup: {
    editGroupNameDrawer: {
      name: {
        value: '',
        touched: false,
        focused: false,
        errorMessage: 'groups:editGroupDrawer.nameFieldRequiredError',
      },
      description: {
        value: '',
        touched: false,
        focused: false,
        errorMessage: null,
      },
      appliesTo: {
        value: '',
      },
    },
    products: [],
    groupRoles: [],
    sharedGroupRoles: {} as ISharedGroupRole,
    usersOptionsFromDrawer: [],
    managedOrgState: {
      selectedManagedOrg: null,
      shareManagedOrgError: null,
    },
    assignRolesTableFromDrawer: [
      {
        selectedProduct: null,
        productsOptions: [],
        rolesOptions: {},
      },
    ],
    activeRemoveAssignedUsers: [],
    activeRemoveAssignedSingleUser: null,
    activeRemoveRoleId: null,
    removedUsersCount: {
      successful: 0,
      failed: 0,
    },
    addedUsersCount: {
      successful: 0,
      failed: 0,
    },
    usersTablePagination: {
      pageSize: TABLE_CONFIG.paginationConfig.pageSize,
      pageIndex: 0,
    },
    userTableSelectedRows: {},
    assignedRolesTablePagination: {
      pageSize: TABLE_CONFIG.paginationConfig.pageSize,
      pageIndex: 0,
    },
    managedOrgsTablePagination: {
      pageSize: TABLE_CONFIG.paginationConfig.pageSize,
      pageIndex: 0,
    },
    assignRolesTable: {
      search: '',
      productFilterOptions: [],
      productFilterSelectedOption: null,
      regionFilterOptions: [],
      regionFilterSelectedOption: null,
      sortingOptions: [{ id: '', desc: false }],
      typeFilterOptions: [],
      typeFilterSelectedOption: null,
    },
    usersTable: {
      search: '',
      sortingOptions: [{ id: '', desc: false }],
    },
    assignRolesDrawer: {
      assignRolesTable: [
        {
          selectedRole: null,
          rolesOptions: [],
          instancesOptions: {},
        },
      ],
    },
    managedOrgsTable: {
      search: '',
      sortingOptions: [{ id: '', desc: false }],
    },
    editedGroupState: {
      data: null,
    },
    managedOrgRemovalModal: {
      visible: false,
      selectedOrg: null,
    },
  },
  mapGroupsStepper: {
    updateGroupMappingsError: null,
    isSubmittingGroupMappings: false,
    currentStep: 1,
    existingMappings: {
      error: null,
      isLoading: false,
      data: null,
    },
    secondStep: {
      rowsData: [],
      createGroupDrawer: {
        name: {
          value: '',
          touched: false,
          focused: false,
          errorMessage: 'groups:editGroupDrawer.nameFieldRequiredError',
        },
        description: {
          value: '',
          touched: false,
          focused: false,
          errorMessage: null,
        },
        data: {
          items: null,
          error: null,
          isIdpGroupLoading: false,
        },
        isCreateGroupDrawerVisible: false,
      },
    },
  },
  notificationType: null,
  errorEventData: {
    type: null,
    groupId: null,
  },
  isDiscardChangesModalVisible: false,
  isDeleteGroupModalVisible: false,
  isEditGroupDrawerVisible: false,
  isAddUsersDrawerVisible: false,
  isAssignRolesDrawerVisible: false,
  isManagedOrgDrawerVisible: false,
  error: null,
  isLoading: false,
  groupsTypeSelectedOption: null,
  removeManagedOrgError: null,
};

export default createReducer(initialState, {
  [SetDrawerRolesTable.TYPE]: (state: IGroups, { payload }: AnyAction) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      assignRolesTableFromDrawer: payload,
    },
  }),

  [FetchGroupById.Success.TYPE]: (state: IGroups, { payload }: AnyAction) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      editedGroupState: {
        data: payload,
      },
    },
  }),

  [FetchGroupUsers.Success.TYPE]: (state: IGroups, { payload }: AnyAction) => ({
    ...state,
    groupUsers: payload,
  }),

  [FetchGroupUsers.Error.TYPE]: (state: IGroups, { payload }: AnyAction) => ({
    ...state,
    groupUsers: [],
  }),

  [DeleteGroup.Success.TYPE]: (state: IGroups) => ({
    ...state,
    isDeleteGroupModalVisible: false,
    activeDeleteGroupId: null,
    groupUsers: [],
  }),

  [SetActiveDeleteGroupId.TYPE]: (state: IGroups, { payload }: AnyAction) => ({
    ...state,
    activeDeleteGroupId: payload,
    activeEditGroupId: null,
  }),

  [ShowDeleteGroupModal.TYPE]: (state: IGroups) => ({
    ...state,
    isDeleteGroupModalVisible: true,
  }),
  [HideDeleteGroupModal.TYPE]: (state: IGroups) => ({
    ...state,
    isDeleteGroupModalVisible: false,
  }),

  [SetManagedOrgRemovalModalVisible.TYPE]: (state: IGroups) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      managedOrgRemovalModal: {
        ...state.editGroup.managedOrgRemovalModal,
        visible: true,
      },
    },
  }),

  [CloseManagedOrgRemovalModal.TYPE]: (state: IGroups) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      managedOrgRemovalModal: {
        ...state.editGroup.managedOrgRemovalModal,
        visible: false,
      },
    },
  }),

  [SetManagedOrgRemovalSelectedItem.TYPE]: (
    state: IGroups,
    { payload }: AnyAction
  ) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      managedOrgRemovalModal: {
        ...state.editGroup.managedOrgRemovalModal,
        selectedOrg: payload,
      },
    },
  }),

  [ChangeNameField.TYPE]: (state: IGroups, { payload }: AnyAction) => ({
    ...state,
    addGroup: {
      ...state.addGroup,
      stepper: {
        ...state.addGroup.stepper,
        name: {
          ...state.addGroup.stepper.name,
          ...payload,
        },
      },
      newGroupName: payload.value || state.addGroup.stepper.name.value,
    },
  }),

  [appliesTo.TYPE]: (state: IGroups, { payload }: AnyAction) => ({
    ...state,
    addGroup: {
      ...state.addGroup,
      stepper: {
        ...state.addGroup.stepper,
        appliesTo: {
          ...state.addGroup.stepper?.appliesTo,
          ...payload,
        },
      },
    },
  }),

  [SetAddGroupStep.TYPE]: (state: IGroups, { payload }: AnyAction) => ({
    ...state,
    addGroup: {
      ...state.addGroup,
      stepper: {
        ...state.addGroup.stepper,
        currentStep: payload,
      },
    },
  }),
  [ChangeDescriptionField.TYPE]: (state: IGroups, { payload }: AnyAction) => ({
    ...state,
    addGroup: {
      ...state.addGroup,
      stepper: {
        ...state.addGroup.stepper,
        description: {
          ...state.addGroup.stepper.description,
          ...payload,
        },
      },
    },
  }),

  [SetUsersOptions.TYPE]: (state: IGroups, { payload }: AnyAction) => ({
    ...state,
    addGroup: {
      ...state.addGroup,
      stepper: {
        ...state.addGroup.stepper,
        usersOptions: payload,
      },
    },
  }),

  [ToggleAssignRolesDrawerVisibility.TYPE]: (
    state: IGroups,
    { payload }: AnyAction
  ) => ({
    ...state,
    isAssignRolesDrawerVisible: payload,
  }),

  [ShowDiscardChangesModal.TYPE]: (state: IGroups) => ({
    ...state,
    isDiscardChangesModalVisible: true,
  }),
  [HideDiscardChangesModal.TYPE]: (state: IGroups) => ({
    ...state,
    isDiscardChangesModalVisible: false,
  }),

  [DiscardAddGroupChanges.TYPE]: (state: IGroups) => ({
    ...state,
    addGroup: {
      ...state.addGroup,
      stepper: initialState.addGroup.stepper,
    },
    isDiscardChangesModalVisible: false,
  }),

  [AddNotification.TYPE]: (state: IGroups, { payload }: AnyAction) => ({
    ...state,
    notificationType: payload,
  }),

  [AddGroupTelemetryErrorNotification.TYPE]: (
    state: IGroups,
    { payload }: AnyAction
  ) => ({
    ...state,
    errorEventData: {
      type: payload.errorEventType,
      groupId: payload.groupId,
    },
  }),

  [HideNotification.TYPE]: (state: IGroups) => ({
    ...state,
    notificationType: null,
  }),

  [ShowAddUsersDrawer.TYPE]: (state: IGroups) => ({
    ...state,
    isAddUsersDrawerVisible: true,
    isDiscardChangesModalVisible: false,
    isDeleteGroupModalVisible: false,
    isEditGroupDrawerVisible: false,
    isAssignRolesDrawerVisible: false,
  }),
  [ShowManagedOrgDrawer.TYPE]: (state: IGroups) => ({
    ...state,
    isManagedOrgDrawerVisible: true,
  }),

  [HideManagedOrgDrawer.TYPE]: (state: IGroups) => ({
    ...state,
    isManagedOrgDrawerVisible: false,
  }),

  [HideAddUsersDrawer.TYPE]: (state: IGroups) => ({
    ...state,
    isAddUsersDrawerVisible: false,
  }),

  [ShowEditGroupNameDrawer.TYPE]: (state: IGroups) => ({
    ...state,
    isEditGroupDrawerVisible: true,
    isDiscardChangesModalVisible: false,
    isDeleteGroupModalVisible: false,
    isAddUsersDrawerVisible: false,
    isAssignRolesDrawerVisible: false,
  }),
  [HideEditGroupNameDrawer.TYPE]: (state: IGroups) => ({
    ...state,
    isEditGroupDrawerVisible: false,
  }),

  [ChangeNameFieldFromDrawer.TYPE]: (
    state: IGroups,
    { payload }: AnyAction
  ) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      editGroupNameDrawer: {
        ...state.editGroup.editGroupNameDrawer,
        name: {
          ...state.editGroup.editGroupNameDrawer.name,
          ...payload,
        },
      },
    },
  }),
  [ChangeDescriptionFieldFromDrawer.TYPE]: (
    state: IGroups,
    { payload }: AnyAction
  ) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      editGroupNameDrawer: {
        ...state.editGroup.editGroupNameDrawer,
        description: {
          ...state.editGroup.editGroupNameDrawer.description,
          ...payload,
        },
      },
    },
  }),

  [ShowAssignRolesDrawer.TYPE]: (state: IGroups) => ({
    ...state,
    isAssignRolesDrawerVisible: true,
    isDiscardChangesModalVisible: false,
    isDeleteGroupModalVisible: false,
    isEditGroupDrawerVisible: false,
    isAddUsersDrawerVisible: false,
  }),
  [HideAssignRolesDrawer.TYPE]: (state: IGroups) => ({
    ...state,
    isAssignRolesDrawerVisible: false,
  }),

  [EditGroup.TYPE]: (state: IGroups, { payload }: AnyAction) => ({
    ...state,
    activeEditGroupId: payload,
  }),

  [SetUsersOptionsFromDrawer.TYPE]: (
    state: IGroups,
    { payload }: AnyAction
  ) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      usersOptionsFromDrawer: payload,
    },
  }),
  [SetSelectedUsersAddGroupDrawer.TYPE]: (
    state: IGroups,
    { payload }: AnyAction
  ) => ({
    ...state,
    addGroup: {
      ...state.addGroup,
      stepper: {
        ...state.addGroup.stepper,
        selectedUsersOptions: payload,
      },
    },
  }),

  [UpdateGroupsSearchField.TYPE]: (state: IGroups, { payload }: AnyAction) => ({
    ...state,
    groupsTableSearchField: payload,
  }),
  [UpdateTableConfigData.TYPE]: (state: IGroups, { payload }: AnyAction) => ({
    ...state,
    groupsPagination: payload,
  }),

  [FetchGroupRoles.Success.TYPE]: (state: IGroups, { payload }: AnyAction) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      products: extractProductsFromRoles(payload),
      groupRoles: payload,
    },
  }),

  [FetchGroupRoles.Error.TYPE]: (state: IGroups, { payload }: AnyAction) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      groupRoles: [],
    },
  }),

  [FetchSharedGroupRoles.Success.TYPE]: (
    state: IGroups,
    { payload }: AnyAction
  ) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      sharedGroupRoles: payload,
    },
  }),

  [FetchSharedGroupRoles.Error.TYPE]: (
    state: IGroups,
    { payload }: AnyAction
  ) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      sharedGroupRoles: {},
    },
  }),

  [HideRemoveModal.TYPE]: (state: IGroups) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      activeRemoveAssignedUsers: [],
      activeRemoveAssignedSingleUser: null,
      activeRemoveRoleId: null,
    },
  }),
  [SelectActiveDeleteUsers.TYPE]: (state: IGroups, { payload }: AnyAction) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      activeRemoveAssignedUsers: payload,
      activeRemoveAssignedSingleUser: null,
    },
  }),
  [SelectActiveDeleteSingleUser.TYPE]: (
    state: IGroups,
    { payload }: AnyAction
  ) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      activeRemoveAssignedUsers: [],
      activeRemoveAssignedSingleUser: payload,
    },
  }),
  [SetRemovedUsersCount.TYPE]: (
    state: IGroups,
    { payload }: { payload: RemovedUserMode }
  ) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      removedUsersCount: {
        ...state.editGroup.removedUsersCount,
        [payload]: state.editGroup.removedUsersCount[payload] + 1,
      },
    },
  }),

  [ClearRemovedUsersCount.TYPE]: (state: IGroups) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      removedUsersCount: initialState.editGroup.removedUsersCount,
    },
  }),

  [SelectActiveDeleteRole.TYPE]: (state: IGroups, { payload }: AnyAction) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      activeRemoveRoleId: payload,
    },
  }),

  [HideAllEditGroupDrawers.TYPE]: (state: IGroups) => ({
    ...state,
    isEditGroupDrawerVisible: false,
    isAddUsersDrawerVisible: false,
    isAssignRolesDrawerVisible: false,
  }),

  [ClearAllEditGroupDrawers.TYPE]: (state: IGroups) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      editGroupNameDrawer: initialState.editGroup.editGroupNameDrawer,
      usersOptionsFromDrawer: initialState.editGroup.usersOptionsFromDrawer,
      assignRolesTableFromDrawer:
        initialState.editGroup.assignRolesTableFromDrawer,
      assignRolesDrawer: initialState.editGroup.assignRolesDrawer,
    },
  }),

  [IncrementAddedUsersCount.TYPE]: (
    state: IGroups,
    { payload }: { payload: AddedUserMode }
  ) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      addedUsersCount: {
        ...state.editGroup.addedUsersCount,
        [payload]: state.editGroup.addedUsersCount[payload] + 1,
      },
    },
  }),

  [ClearAddedUsersCount.TYPE]: (state: IGroups) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      addedUsersCount: initialState.editGroup.addedUsersCount,
    },
  }),

  [SetProductFilterOptions.TYPE]: (state: IGroups, { payload }: AnyAction) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      assignRolesTable: {
        ...state.editGroup.assignRolesTable,
        productFilterOptions: payload,
      },
    },
  }),
  [SetRegionFilterOptions.TYPE]: (state: IGroups, { payload }: AnyAction) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      assignRolesTable: {
        ...state.editGroup.assignRolesTable,
        regionFilterOptions: payload,
      },
    },
  }),
  [SetProductFilterSelectedOption.TYPE]: (
    state: IGroups,
    { payload }: AnyAction
  ) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      assignRolesTable: {
        ...state.editGroup.assignRolesTable,
        productFilterSelectedOption: payload,
      },
    },
  }),
  [SetTypeFilterOptions.TYPE]: (state: IGroups, { payload }: AnyAction) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      assignRolesTable: {
        ...state.editGroup.assignRolesTable,
        typeFilterOptions: payload,
      },
    },
  }),
  [SetTypeFilterSelectedOption.TYPE]: (
    state: IGroups,
    { payload }: AnyAction
  ) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      assignRolesTable: {
        ...state.editGroup.assignRolesTable,
        typeFilterSelectedOption: payload,
      },
    },
  }),
  [SetAssignedRolesTablePagination.TYPE]: (
    state: IGroups,
    { payload }: AnyAction
  ) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      assignedRolesTablePagination: payload,
    },
  }),
  [SetManagedOrgsTablePagination.TYPE]: (
    state: IGroups,
    { payload }: AnyAction
  ) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      managedOrgsTablePagination: payload,
    },
  }),
  [SetUsersTablePagination.TYPE]: (state: IGroups, { payload }: AnyAction) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      usersTablePagination: payload,
    },
  }),
  [SetAssignedRolesTableSearch.TYPE]: (
    state: IGroups,
    { payload }: AnyAction
  ) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      assignRolesTable: {
        ...state.editGroup.assignRolesTable,
        search: payload,
      },
    },
  }),
  [SetManagedOrgsTableSearch.TYPE]: (
    state: IGroups,
    { payload }: AnyAction
  ) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      managedOrgsTable: {
        ...state.editGroup.managedOrgsTable,
        search: payload,
      },
    },
  }),
  [SetRolesTableSorting.TYPE]: (state: IGroups, { payload }: AnyAction) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      assignRolesTable: {
        ...state.editGroup.assignRolesTable,
        sortingOptions: payload,
      },
    },
  }),
  [SetManagedOrgsTableSorting.TYPE]: (
    state: IGroups,
    { payload }: AnyAction
  ) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      managedOrgsTable: {
        ...state.editGroup.managedOrgsTable,
        sortingOptions: payload,
      },
    },
  }),
  [SetUserTableSelectedRows.TYPE]: (
    state: IGroups,
    { payload }: AnyAction
  ) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      userTableSelectedRows: payload,
    },
  }),
  [SetUsersTableSearch.TYPE]: (state: IGroups, { payload }: AnyAction) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      usersTable: {
        ...state.editGroup.usersTable,
        search: payload,
      },
    },
  }),
  [SetUsersTableSorting.TYPE]: (state: IGroups, { payload }: AnyAction) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      usersTable: {
        ...state.editGroup.usersTable,
        sortingOptions: payload,
      },
    },
  }),

  [SetAssignRolesTableDrawer.TYPE]: (
    state: IGroups,
    { payload }: PayloadAction<IRolesRows[]>
  ) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      assignRolesDrawer: {
        ...state.editGroup.assignRolesDrawer,
        assignRolesTable: payload,
      },
    },
  }),

  [SetMapGroupRowsData.TYPE]: (state: IGroups, { payload }: AnyAction) => ({
    ...state,
    mapGroupsStepper: {
      ...state.mapGroupsStepper,
      secondStep: {
        ...state.mapGroupsStepper.secondStep,
        rowsData: payload.map((row: IMapGroupFormRow[], rowIndex: number) => ({
          ...row,
          rowIndex,
        })),
      },
    },
  }),

  [SetMapIdentityProviderStep.TYPE]: (
    state: IGroups,
    { payload }: AnyAction
  ) => ({
    ...state,
    mapGroupsStepper: {
      ...state.mapGroupsStepper,
      currentStep: payload,
    },
  }),

  [ClearMapGroupsStepper.TYPE]: (state: IGroups) => ({
    ...state,
    mapGroupsStepper: {
      ...initialState.mapGroupsStepper,
      existingMappings: {
        ...state.mapGroupsStepper.existingMappings,
      },
    },
  }),

  [CreateGroup.Pending.TYPE]: (state: IGroups) => ({
    ...state,
    mapGroupsStepper: {
      ...state.mapGroupsStepper,
      secondStep: {
        ...state.mapGroupsStepper.secondStep,
        createGroupDrawer: {
          ...state.mapGroupsStepper.secondStep.createGroupDrawer,
          data: {
            ...state.mapGroupsStepper.secondStep.createGroupDrawer.data,
            isIdpGroupLoading: true,
          },
        },
      },
    },
  }),

  [CreateGroup.Success.TYPE]: (state: IGroups, { payload }: AnyAction) => ({
    ...state,
    mapGroupsStepper: {
      ...state.mapGroupsStepper,
      secondStep: {
        ...state.mapGroupsStepper.secondStep,
        createGroupDrawer: {
          ...state.mapGroupsStepper.secondStep.createGroupDrawer,
          appliesTo: {
            value: '',
          },
          name: {
            value: '',
            touched: false,
            focused: false,
            errorMessage: 'groups:editGroupDrawer.nameFieldRequiredError',
          },
          description: {
            value: '',
            touched: false,
            focused: false,
            errorMessage: null,
          },
          data: {
            ...state.mapGroupsStepper.secondStep.createGroupDrawer.data,
            items: payload,
            isIdpGroupLoading: false,
          },
        },
      },
    },
  }),

  [CreateGroup.Error.TYPE]: (state: IGroups, { payload }: AnyAction) => ({
    ...state,
    mapGroupsStepper: {
      ...state.mapGroupsStepper,
      secondStep: {
        ...state.mapGroupsStepper.secondStep,
        createGroupDrawer: {
          ...state.mapGroupsStepper.secondStep.createGroupDrawer,
          data: {
            ...state.mapGroupsStepper.secondStep.createGroupDrawer.data,
            isIdpGroupLoading: false,
            error: payload,
          },
        },
      },
    },
    error: payload,
  }),

  [ToggleGroupsDrawerVisibility.TYPE]: (
    state: IGroups,
    { payload }: AnyAction
  ) => ({
    ...state,
    mapGroupsStepper: {
      ...state.mapGroupsStepper,
      secondStep: {
        ...state.mapGroupsStepper.secondStep,
        createGroupDrawer: {
          ...state.mapGroupsStepper.secondStep.createGroupDrawer,
          isCreateGroupDrawerVisible: payload,
        },
      },
    },
  }),

  [ChangeNameForNewGroupIdpStepper.TYPE]: (
    state: IGroups,
    { payload }: AnyAction
  ) => ({
    ...state,
    mapGroupsStepper: {
      ...state.mapGroupsStepper,
      secondStep: {
        ...state.mapGroupsStepper.secondStep,
        createGroupDrawer: {
          ...state.mapGroupsStepper.secondStep.createGroupDrawer,
          name: {
            ...state.mapGroupsStepper.secondStep.createGroupDrawer.name,
            ...payload,
          },
        },
      },
    },
  }),

  [ChangeDescriptionForNewGroupIdpStepper.TYPE]: (
    state: IGroups,
    { payload }: AnyAction
  ) => ({
    ...state,
    mapGroupsStepper: {
      ...state.mapGroupsStepper,
      secondStep: {
        ...state.mapGroupsStepper.secondStep,
        createGroupDrawer: {
          ...state.mapGroupsStepper.secondStep.createGroupDrawer,
          description: {
            ...state.mapGroupsStepper.secondStep.createGroupDrawer.description,
            ...payload,
          },
        },
      },
    },
  }),

  [FetchGroupMappings.Success.TYPE]: (
    state: IGroups,
    { payload }: AnyAction
  ) => ({
    ...state,
    mapGroupsStepper: {
      ...state.mapGroupsStepper,
      existingMappings: {
        error: null,
        isLoading: false,
        data: payload,
      },
    },
  }),

  [FetchGroupMappings.Pending.TYPE]: (state: IGroups) => ({
    ...state,
    mapGroupsStepper: {
      ...state.mapGroupsStepper,
      existingMappings: {
        ...state.mapGroupsStepper.existingMappings,
        error: null,
        isLoading: true,
      },
    },
  }),

  [FetchGroupMappings.Error.TYPE]: (
    state: IGroups,
    { payload }: AnyAction
  ) => ({
    ...state,
    mapGroupsStepper: {
      ...state.mapGroupsStepper,
      existingMappings: {
        ...state.mapGroupsStepper.existingMappings,
        error: payload,
        isLoading: false,
      },
    },
  }),

  [UpdateGroupMappings.Error.TYPE]: (
    state: IGroups,
    { payload }: AnyAction
  ) => ({
    ...state,
    mapGroupsStepper: {
      ...state.mapGroupsStepper,
      updateGroupMappingsError: payload,
    },
  }),

  [CloseMapGroupsErrorBanner.TYPE]: (state: IGroups) => ({
    ...state,
    mapGroupsStepper: {
      ...state.mapGroupsStepper,
      updateGroupMappingsError: null,
    },
  }),

  [CloseGetIdpGroupsErrorBanner.TYPE]: (state: IGroups) => ({
    ...state,
    idpGroups: {
      ...state.idpGroups,
      error: null,
    },
  }),

  [FetchIdpGroups.Success.TYPE]: (state: IGroups, { payload }: AnyAction) => ({
    ...state,
    idpGroups: {
      data: payload,
      error: null,
    },
  }),

  [FetchIdpGroups.Error.TYPE]: (state: IGroups, { payload }: AnyAction) => ({
    ...state,
    idpGroups: {
      ...state.idpGroups,
      error: { traceId: payload?.response?.data?.traceId ?? null },
    },
  }),

  [RemoveManagedOrg.Success.TYPE]: (state: IGroups) => ({
    ...state,
    removeManagedOrgError: false,
  }),

  [RemoveManagedOrgErrorBanner.TYPE]: (state: IGroups) => ({
    ...state,
    removeManagedOrgError: null,
  }),

  [RemoveManagedOrg.Error.TYPE]: (state: IGroups) => ({
    ...state,
    removeManagedOrgError: true,
  }),

  [ClearEditGroup.TYPE]: (state: IGroups) => ({
    ...state,
    editGroup: initialState.editGroup,
  }),

  [SetGroupsTypeSelectedFilter.TYPE]: (
    state: IGroups,
    { payload }: AnyAction
  ) => ({
    ...state,
    groupsTypeSelectedOption: payload,
  }),

  [SetSelectedManagedOrg.TYPE]: (state: IGroups, { payload }: AnyAction) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      managedOrgState: {
        ...state.editGroup.managedOrgState,
        selectedManagedOrg: payload,
        shareManagedOrgError: null,
      },
    },
  }),

  [ShareManagedOrganization.Success.TYPE]: (state: IGroups) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      managedOrgState: {
        ...state.editGroup.managedOrgState,
        shareManagedOrgError: null,
      },
    },
    isManagedOrgDrawerVisible: false,
  }),

  [ShareManagedOrganization.Error.TYPE]: (
    state: IGroups,
    { payload }: AnyAction
  ) => ({
    ...state,
    editGroup: {
      ...state.editGroup,
      managedOrgState: {
        ...state.editGroup.managedOrgState,
        shareManagedOrgError: payload?.response?.data?.traceId || null,
      },
    },
  }),
});
